<!-- header -->

<header class="d-print-none p-1 " style="top: 0;z-index: 99999;">

    <!-- پشتیبانی تلگرام -->

    <div *ngIf="!bHideTG" class="tel-sup d-flex justify-content-center align-items-center">

        <button class="learn-more">

        </button>

    </div>

    <!-- هدر اصلی سایت -->

    <div class="app-header d-flex flex-row-reverse justify-content-between gx-2 px-2 p-1">

        <!-- قسمت سمت راست هدر اصلی -->

        <div class="d-flex justify-content-start align-items-center flex-row-reverse ">

            <div class="app-logo col-12 col-md-6 pointer" (click)="changeRoute('home')">

                <img class="w-100 h-100" src="../../../assets/imgs/Shahrnik_Logo_Public_new.png" alt="تاکسی لون صفحه اصلی">

            </div>

            <div class="central menu_links">

                <span class="pointer" routerLink="/taxilon/about">درباره ما</span>

                <span class="pointer" routerLink="/taxilon/about">

                    <a style="color: inherit;" target="_blank" href="/taxilon/drivers">

                        نسخه رانندگان

                    </a>

                </span>

                <!-- <span class="pointer" routerLink="/taxilon-marketers"> همکاران تاکسی لون</span> -->

                <span class="pointer" *ngIf="!isLogin" (click)="login('NewTrip')"> رزرو تاکسی بین شهری </span>

                <span class="pointer" *ngIf="isLogin" routerLink="/taxilon/NewTrip"> رزرو تاکسی بین شهری</span>

                <span class="pointer" routerLink="/taxilon/home">خانه</span>

            </div>

        </div>

        <!-- قسمت سمت چپ هدر اصلی  -->

        <div class="app-header-buttons d-flex flex-row-reverse justify-content-end align-items-center">

            <div (click)="login('home')" *ngIf="!isLogin" class="central profile">

                <span>پنل کاربری</span>

                <mat-icon>person</mat-icon>

            </div>

            <div *ngIf="isLogin" routerLink="/taxilon/Profile" class="central profile">

                <span *ngIf="isLogin">

                    {{ diar_UserInfo.strFullName }}

                </span>

                <mat-icon>person</mat-icon>

            </div>

            <div class="my-diar p-1 rounded-md dropdown">

                <button class="d-flex align-items-center w-100 text-primary justify-content-between" type="button"

                    id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">

                    <mat-icon>menu</mat-icon>

                </button>

                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style="z-index: 10001!important;">

                    <!-- اگر کاربر لاگین نبود -->

                    <ng-container *ngIf="!isLogin">

                        <!-- پنل کاربری -->

                        <li class="dropdown-login">

                            <a (click)="login('home')" class="dropdown-item"> پنل کاربری

                                <mat-icon class="text-muted"> login </mat-icon>

                            </a>

                        </li>



                    </ng-container>

                    <!-- اگر کاربر لاگین کرده بود -->

                    <ng-container *ngIf="isLogin">

                        <!-- پروفایل کاربر -->

                        <li class="list-item-dyar">

                            <a class="dropdown-item" routerLink="/taxilon/Profile">

                                {{ diar_UserInfo.strFullName }}

                                <mat-icon class="text-success"> how_to_reg </mat-icon>

                            </a>
                        </li>

                        <!-- صورتحساب های من -->

                        <li routerLink="/taxilon/allTrip" class="list-item-dyar">

                            <a class="dropdown-item">

                                سفر های من

                                <mat-icon class="text-muted"> receipt_long </mat-icon>

                            </a>
                        </li>

                        <!-- پشتیبانی -->

                        <li routerLink="/taxilon/Support" class="list-item-dyar">

                            <a class="dropdown-item">

                                پشتیبانی و شکایات

                                <mat-icon class="text-muted"> contact_support </mat-icon>

                            </a>

                        </li>

                    </ng-container>

                    <!-- نسخه رانندگان -->

                    <li *ngIf="mobileUser" class="list-item-dyar">

                        <a class="dropdown-item" href="https://cafebazaar.ir/app/com.rayanandishe.taxilon" target="_blank">

                            نسخه رانندگان

                            <mat-icon class="text-muted"> local_taxi </mat-icon>

                        </a>

                    </li>

                    <!-- همکاران تاکسی لون  -->

                    <li routerLink="/partners" class="list-item-dyar">
                        
                        <a class="dropdown-item">

                            همکاران تاکسی لون 

                            <mat-icon class="text-muted"> handshake </mat-icon>

                        </a>

                    </li>

                    <!-- قوانین و مقررات -->

                    <li routerLink="/taxilon/general" class="list-item-dyar">

                        <a class="dropdown-item">

                            شرایط استفاده

                            <mat-icon class="text-muted"> gavel </mat-icon>

                        </a>

                    </li>

                    <!-- درباره دیار -->

                    <li routerLink="/taxilon/about" class="list-item-dyar">

                        <a class="dropdown-item"> درباره ما

                            <mat-icon class="text-muted"> info </mat-icon>

                        </a>

                    </li>

                    <!-- خروج -->

                    <ng-container *ngIf="isLogin">

                        <li class="list-item-dyar">

                            <a (click)="logOut()" class="dropdown-item"> خروج

                                <mat-icon class="text-muted"> logout </mat-icon>
                            </a>

                        </li>

                    </ng-container>

                </ul>

            </div>

        </div>

    </div>

</header>

<!-- مدل تعرفه تبلیغات -->

<div class="modal fade dir" id="Fee_Modal" tabindex="4" role="dialog" aria-hidden="true"
    style="z-index: 10000000000000!important;">

    <div style="width:90%;" class="modal-dialog modal-lg modal-dialog-centered">

        <div class="modal-content modal-lg">

            <div class="modal-content">

                <div class="modal-header d-flex justify-content-between">

                    <h3 class="modal-title mb-0"> تعرفه تبلیغات در دیار </h3>

                    <button type="button" class="btn-close p-0 m-0" data-bs-dismiss="modal" aria-label="Close"></button>

                </div>

                <div class="modal-body d-flex flex-column align-items-center">

                    <div class="row gx-2 gy-3 p-2 w-100">

                        <!-- هزینه ثبت یک آگهی  در دیار -->

                        <div class="col-12">

                            <p class="mb-0 text-label"> هزینه ثبت یک آگهی در دیار :

                                <span style="color: navy;font-size: 17px;"
                                    [ngStyle]="{'text-decoration': obj_Tablighat.fFirtsAdvertising > 0 ? 'underline' : 'none' }">

                                    {{

                                    obj_Tablighat.fFirtsAdvertising == -1 ? 'توافقی' :

                                    obj_Tablighat.fFirtsAdvertising == 0 ? 'رایگان' :

                                    obj_Tablighat.fFirtsAdvertising?.toLocaleString() + ' ' + strCurrency | faNum

                                    }}

                                </span>

                            </p>

                        </div>

                        <!-- هزینه ثبت آگهی دوم به بعد در دیار به ازای هر آگهی -->

                        <div class="col-12">

                            <p class="mb-0 text-label"> هزینه ثبت آگهی دوم به بعد در دیار به ازای هر آگهی :

                                <span style="color: navy;font-size: 17px;"
                                    [ngStyle]="{'text-decoration': obj_Tablighat.fSecoundAdvertising > 0 ? 'underline' : 'none' }">

                                    {{

                                    obj_Tablighat.fSecoundAdvertising == -1 ? 'توافقی' :

                                    obj_Tablighat.fSecoundAdvertising == 0 ? 'رایگان' :

                                    obj_Tablighat.fSecoundAdvertising?.toLocaleString() + ' ' + strCurrency | faNum

                                    }}

                                </span>

                            </p>

                        </div>

                        <!-- هزینه ویژه سازی آگهی برای یک هفته  -->

                        <div class="col-12">

                            <p class="mb-0 text-label"> هزینه ویژه سازی آگهی برای یک هفته :

                                <span style="color: navy;font-size: 17px;"
                                    [ngStyle]="{'text-decoration': obj_Tablighat.fVIPAdvertising > 0 ? 'underline' : 'none' }">

                                    {{

                                    obj_Tablighat.fVIPAdvertising == -1 ? 'توافقی' :

                                    obj_Tablighat.fVIPAdvertising == 0 ? 'رایگان' :

                                    obj_Tablighat.fVIPAdvertising?.toLocaleString() + ' ' + strCurrency | faNum

                                    }}

                                </span>

                            </p>

                        </div>

                        <!-- هزینه معرفی کسب و کار در دیار  -->

                        <div class="col-12">

                            <p class="mb-0 text-label"> هزینه معرفی کسب و کار در دیار :

                                <span style="color: navy;font-size: 17px;"
                                    [ngStyle]="{'text-decoration': obj_Tablighat.fResume > 0 ? 'underline' : 'none' }">

                                    {{

                                    obj_Tablighat.fResume == -1 ? 'توافقی' :

                                    obj_Tablighat.fResume == 0 ? 'رایگان' :

                                    obj_Tablighat.fResume?.toLocaleString() + ' ' + strCurrency | faNum

                                    }}

                                </span>

                            </p>

                        </div>

                        <!-- هزینه ویژه سازی کسب و کار در دیار برای یک هفته  -->

                        <div class="col-12">

                            <p class="mb-0 text-label"> هزینه ویژه سازی کسب و کار در دیار برای یک هفته :

                                <span style="color: navy;font-size: 17px;"
                                    [ngStyle]="{'text-decoration': obj_Tablighat.fVIPResume > 0 ? 'underline' : 'none' }">

                                    {{

                                    obj_Tablighat.fVIPResume == -1 ? 'توافقی' :

                                    obj_Tablighat.fVIPResume == 0 ? 'رایگان' :

                                    obj_Tablighat.fVIPResume?.toLocaleString() + ' ' + strCurrency | faNum

                                    }}

                                </span>

                            </p>

                        </div>

                        <!-- هزینه تبلیغ پاپ آپی تا یک هفته  -->

                        <div class="col-12">

                            <p class="mb-0 text-label"> هزینه تبلیغ پاپ آپ تا یک هفته :

                                <span style="color: navy;font-size: 17px;"
                                    [ngStyle]="{'text-decoration': obj_Tablighat.fPopupAdvertising > 0 ? 'underline' : 'none' }">

                                    {{

                                    obj_Tablighat.fPopupAdvertising == -1 ? 'توافقی' :

                                    obj_Tablighat.fPopupAdvertising == 0 ? 'رایگان' :

                                    obj_Tablighat.fPopupAdvertising?.toLocaleString() + ' ' + strCurrency | faNum

                                    }}

                                </span>

                            </p>

                        </div>

                        <!-- هزینه هر پنل تبلیغ در صفحه اصلی  -->

                        <div class="col-12">

                            <p class="mb-0 text-label"> هزینه هر پنل تبلیغ در صفحه اصلی :

                                <span style="color: navy;font-size: 17px;"
                                    [ngStyle]="{'text-decoration': obj_Tablighat.fAdvertising_MainPage > 0 ? 'underline' : 'none' }">

                                    {{

                                    obj_Tablighat.fAdvertising_MainPage == -1 ? 'توافقی' :

                                    obj_Tablighat.fAdvertising_MainPage == 0 ? 'رایگان' :

                                    obj_Tablighat.fAdvertising_MainPage?.toLocaleString() + ' ' + strCurrency | faNum

                                    }}

                                </span>

                            </p>

                        </div>

                        <!-- هزینه هر پنل تبلیغ در صفحه آگهی ها  -->

                        <div class="col-12">

                            <p class="mb-0 text-label"> هزینه هر پنل تبلیغ در صفحه آگهی ها :

                                <span style="color: navy;font-size: 17px;"
                                    [ngStyle]="{'text-decoration': obj_Tablighat.fAdvertising_AdvertisingPage > 0 ? 'underline' : 'none' }">

                                    {{

                                    obj_Tablighat.fAdvertising_AdvertisingPage == -1 ? 'توافقی' :

                                    obj_Tablighat.fAdvertising_AdvertisingPage == 0 ? 'رایگان' :

                                    obj_Tablighat.fAdvertising_AdvertisingPage?.toLocaleString() + ' ' + strCurrency |
                                    faNum

                                    }}

                                </span>

                            </p>

                        </div>

                        <!-- هزینه هر پنل تبلیغ در صفحه کسب و کار  -->

                        <div class="col-12">

                            <p class="mb-0 text-label"> هزینه هر پنل تبلیغ در صفحه کسب و کار :

                                <span style="color: navy;font-size: 17px;"
                                    [ngStyle]="{'text-decoration': obj_Tablighat.fAdvertising_ResumePage > 0 ? 'underline' : 'none' }">

                                    {{

                                    obj_Tablighat.fAdvertising_ResumePage == -1 ? 'توافقی' :

                                    obj_Tablighat.fAdvertising_ResumePage == 0 ? 'رایگان' :

                                    obj_Tablighat.fAdvertising_ResumePage?.toLocaleString() + ' ' + strCurrency | faNum

                                    }}

                                </span>


                            </p>

                        </div>

                    </div>

                </div>


                <div class="modal-footer d-flex justify-content-start align-items-center ">

                    <button class="btn btn-primary text-secondary fw-bold" (click)="changeRoute('support')"> ثبت درخواست
                        تبلیغات </button>

                    <button class="btn btn-primary text-secondary fw-bold">

                        <a target="_blank" class="text-secondary" href="https://t.me/{{helpTxt}}">

                            ارتباط با پشتیبانی دیار

                        </a>

                    </button>

                </div>

            </div>

        </div>

    </div>

</div>

<main style="direction: rtl;padding: 0!important;">

    <router-outlet></router-outlet>

</main>